"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

const Hash = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 14 16"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M8.205 11.2H5.104l-.442 4.088a.783.783 0 0 1-.859.707.795.795 0 0 1-.687-.883l.422-3.912H.778A.79.79 0 0 1 0 10.4c0-.442.348-.8.778-.8H3.71l.346-3.2H.777A.79.79 0 0 1 0 5.6c0-.442.348-.8.778-.8H4.23L4.67.712a.783.783 0 0 1 .86-.707.795.795 0 0 1 .686.883L5.795 4.8h3.101L9.338.712a.783.783 0 0 1 .859-.707.795.795 0 0 1 .687.883L10.462 4.8h2.76a.79.79 0 0 1 .778.8.79.79 0 0 1-.778.8H10.29l-.346 3.2h3.28a.79.79 0 0 1 .777.8.79.79 0 0 1-.778.8H9.77l-.441 4.088a.783.783 0 0 1-.86.707.795.795 0 0 1-.686-.883l.422-3.912zm.173-1.6l.346-3.2H5.622l-.346 3.2h3.102z",
  className: "fill"
}));

var _default = Hash;
exports.default = _default;